export default __webpack_public_path__ + "static/media/youtube.023c7e31.svg";